module.exports = __webpack_public_path__ + "static/media/beach-off.d50c8a28.png";